import { resolveMediaUrl } from "../../../utils/media-url";
import React from "react";
import { useTranslation } from "react-i18next";
export default function MobileFreeFormNotice({ item, onBack }: { item?: any; onBack: () => void }) {
  const { t } = useTranslation("tool");
  const preview = item?.tool?.preview_image?.file_field;
  const src = resolveMediaUrl(preview);
  return <section className="mobile-freeform-notice">
    <p role="status">{t("freeform desktop only")}</p>
    {src && <img src={src} alt={item?.tool?.name || t("preview")} />}
    <button type="button" onClick={onBack}>{t(item ? "close freeform preview" : "return to rebar catalog")}</button>
  </section>;
}
